import { useState, useEffect } from 'react';
import Hourglass from '../../assets/icons/hourglass.png';
import Icon from '../../../../../../components/bases/icone/icon';

const HourglassIcon = ({ correcting }) => {
  const [rotation, setRotation] = useState(0);

  useEffect(() => {
    if (correcting) {
      const interval = setInterval(() => {
        setRotation((prevRotation) => {
          if (prevRotation === 0) {
            return 180;
          } else {
            return 0;
          }
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [correcting]);

  if (!correcting) {
    return <></>;
  }

  return (
    <div style={{ transform: `rotate(${rotation}deg)` }}>
      <Icon width={16} height={16} image={Hourglass} alt="" />
    </div>
  );
};

export default HourglassIcon;
